module.exports = crypto;


//////////////////
// WEBPACK FOOTER
// external "crypto"
// module id = 113
// module chunks = 0